module.exports = __webpack_public_path__ + "static/media/June_2026_2.0e41adb7.webp";